"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getAssetsFromBackend = function getAssetsFromBackend(portalId) {
  var dynamicFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    type: 'FIND_ASSETS_FOR_ADMINISTRATION_REQUEST',
    headers: {
      version: 'v2',
      portalId: portalId
    },
    body: {
      dynamicFilters: dynamicFilters
    }
  };
};

var useAdminAssets = function useAdminAssets(portalId) {
  var dynamicFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var query = (0, _reactQuery.useQuery)(['admin.assets', {
    portalId: portalId
  }], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _yield$request, body;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return request(getAssetsFromBackend(portalId, dynamicFilters));

          case 2:
            _yield$request = _context.sent;
            body = _yield$request.body;
            return _context.abrupt("return", body === null || body === void 0 ? void 0 : body.assets);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), options);
  return query;
};

var _default = useAdminAssets;
exports["default"] = _default;